
export default {
  name: 'DaysCalculator',
  jsonld() {
    return {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [{
        "@type": "Question",
        "name": "How do you calculate manydays between two dates?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "The general rule of thumb for calculating the number of days between two different events is subtracting the last day from the start date. For a short period, convert the results to days, weeks, or months. It would help if you did the conversions to the number of years for more significant digits."
        }
      },{
        "@type": "Question",
        "name": "How do you count the number of days?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "To calculate the number of days between two dates, you subtract the start date from the end date."
        }
      },{
        "@type": "Question",
        "name": "How do you calculate the number of days in a month?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Once the number of days result is available, multiply the result by 30.436875 to convert the monthly measurement to a labor day measure."
        }
      },{
        "@type": "Question",
        "name": "How do we calculate time?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "To calculate the time, you need to apply the formula: Time = Distance/Speed. Depending on distance and speed, you will have separate time units."
        }
      },{
        "@type": "Question",
        "name": "How do you calculate days between two dates manually?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "To manually calculate the distance between two dates, our general formula should subtract the start date from the last date."
        }
      }]
    };
  },
  head() {
    return {
      link: [
        { rel: 'stylesheet', href: '/assets/css/vendors.min.css' }
      ]
    }
  },
  mounted: function () {
    new Litepicker({
    element: document.getElementById('datepicker-startDate'),
    startDate: new Date(),
    buttonText: {
      previousMonth: `<svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><polyline points="15 6 9 12 15 18" /></svg>`,
      nextMonth: `<svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><polyline points="9 6 15 12 9 18" /></svg>`,
    }
    });

    new Litepicker({
    element: document.getElementById('datepicker-endDate'),
    startDate: new Date(),
    buttonText: {
      previousMonth: `<svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><polyline points="15 6 9 12 15 18" /></svg>`,
      nextMonth: `<svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><polyline points="9 6 15 12 9 18" /></svg>`,
    }
    });
  },
  data () {
    return {
      data: '',
      form: this.$vform({
        startDate: '',
        endDate: ''
      })
    }
  },
  methods: {
    onDaysCalculator() {
        this.form.startDate = jQuery('#datepicker-startDate').val();
        this.form.endDate   = jQuery('#datepicker-endDate').val();
        this.form.post(`/tool/days-calculator`, { progress: false }).then(res => {
          this.data = res.data;
        }).catch(e => {
          console.log(e);
        });
    }
  }
}
